import { useFrame } from '@react-three/fiber';
import DamselClass from '../../classes/Damsel'
import { SkeletonMesh } from '@esotericsoftware/spine-threejs';

function Cursor({ heldTool }: { heldTool: SkeletonMesh | null }) {
  const scale = DamselClass.getOptions({}).scale
  useFrame((state, delta) => {
    if(heldTool) {
      const x = state.pointer.x * state.size.width/2
      const y = state.pointer.y * state.size.height/2
      heldTool.position.x = x
      heldTool.position.y = y
      heldTool?.update(delta)
    }
  })  

  if(!heldTool) {
    return null
  }

  return <primitive object={heldTool} scale={scale} />
}

export default Cursor